// Light is the default. Studio dark is opt-in via the Profile Drawer toggle.
const KEY = "cdd_theme";

export function getStoredTheme() {
  try {
    const t = localStorage.getItem(KEY);
    return t === "dark" ? "dark" : "light";
  } catch {
    return "light";
  }
}

export function applyTheme(theme) {
  const root = document.documentElement;
  if (theme === "light") {
    root.classList.remove("dark");
    root.classList.add("light");
  } else {
    root.classList.remove("light");
    root.classList.add("dark");
  }
  root.setAttribute("data-theme", theme);
}

export function setTheme(theme) {
  const next = theme === "dark" ? "dark" : "light";
  try { localStorage.setItem(KEY, next); } catch { /* ignore */ }
  applyTheme(next);
  return next;
}

export function initTheme() {
  applyTheme(getStoredTheme());
}
